export default __webpack_public_path__ + "static/media/bg.cbc228fe.png";